(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMission(root) {
    const el = root.querySelector('[data-owen-mission]');
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    const sec = el.closest('.owen-mission');
    if (reduce || !('IntersectionObserver' in window)) { sec.classList.add('is-static'); return; }
    const words = [...el.querySelectorAll('.w')];
    const onScroll = () => {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      const n = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('on', i < n));
    };
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        // capture: strona przewija się w .page-wrapper, nie w window
        if (e.isIntersecting) document.addEventListener('scroll', onScroll, { passive: true, capture: true });
        else document.removeEventListener('scroll', onScroll, { capture: true });
      });
      onScroll();
    });
    io.observe(el);
  }

  function initCountdown(root) {
    root.querySelectorAll('[data-owen-xmas]').forEach((el) => {
      const now = new Date();
      let y = now.getFullYear();
      let target = new Date(y, 11, 24);
      if (now > new Date(y, 11, 24, 23, 59)) target = new Date(y + 1, 11, 24);
      // round, nie ceil: zmiana czasu (koniec października) dodaje godzinę i ceil dawał dzień za dużo
      const days = Math.round((target - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
      const out = el.querySelector('b');
      const verb = el.querySelector('[data-owen-xmas-verb]');
      if (days === 0) { if (verb) verb.textContent = 'Wesołych Świąt!'; if (out) out.remove(); el.hidden = false; return; }
      const few = days % 10 >= 2 && days % 10 <= 4 && !(days % 100 >= 12 && days % 100 <= 14);
      if (verb) verb.textContent = 'Do Wigilii ' + (days === 1 ? 'został' : few ? 'zostały' : 'zostało');
      if (out) out.textContent = days + ' ' + (days === 1 ? 'dzień' : 'dni');
      el.hidden = false;
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-owen-tabs]').forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const tabs = [...wrap.querySelectorAll('[role="tab"]')];
      const select = (t) => {
        tabs.forEach((x) => {
          const on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          const p = wrap.querySelector('#' + x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          n.focus(); select(n);
        });
      });
    });
  }

  function initSeo(root) {
    root.querySelectorAll('[data-owen-seo]').forEach((sec) => {
      const btn = sec.querySelector('.owen-seo__toggle');
      if (!btn || btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', () => {
        const open = sec.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
  }

  async function addToCart(form) {
    const btn = form.querySelector('button[type="submit"]');
    const id = form.querySelector('[name="id"]').value;
    const qty = Number(form.querySelector('[name="quantity"]')?.value || 1);
    if (typeof window.owenCartAdd !== 'function' && typeof window.owenCartAddItems === 'function') {
      window.owenCartAdd = (vid, q, el) => window.owenCartAddItems([{ id: vid, quantity: q }], el);
    }
    if (typeof window.owenCartAdd !== 'function') { form.submit(); return; }
    const label = btn.innerHTML;
    btn.disabled = true;
    try {
      await window.owenCartAdd(Number(id), qty, btn);
      btn.disabled = false;
      btn.classList.add('is-ok');
      btn.innerHTML = btn.dataset.added;
      setTimeout(() => { btn.classList.remove('is-ok'); btn.innerHTML = label; }, 2200);
    } catch (e) {
      btn.disabled = false;
      form.submit();
    }
  }

  const pln = (cents) => (cents / 100).toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' });

  function initFbt(root) {
    root.querySelectorAll('[data-owen-fbt]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const items = [...box.querySelectorAll('.owen-fbt__it')];
      const total = box.querySelector('[data-owen-fbt-total]');
      const btn = box.querySelector('[data-owen-fbt-add]');
      const sum = () => {
        let t = 0;
        items.forEach((it) => {
          const cb = it.querySelector('input');
          it.classList.toggle('is-on', cb.checked);
          if (cb.checked) t += Number(it.dataset.price);
        });
        total.textContent = pln(t);
      };
      items.forEach((it) => it.querySelector('input').addEventListener('change', sum));
      sum();
      btn.addEventListener('click', async () => {
        const list = items.filter((it) => it.querySelector('input').checked).map((it) => ({ id: Number(it.dataset.id), quantity: 1 }));
        const label = btn.innerHTML;
        btn.disabled = true;
        try {
          if (typeof window.owenCartAddItems === 'function') await window.owenCartAddItems(list, btn);
          else { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) }); window.location.href = '/cart'; }
          btn.innerHTML = btn.dataset.added;
          setTimeout(() => { btn.innerHTML = label; }, 2200);
        } finally { btn.disabled = false; }
      });
    });
  }

  function initReveal(root) {
    const els = root.querySelectorAll('.owen-reveal:not(.is-in), [data-owen-inview]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      e.target.querySelectorAll?.('[data-owen-count]').forEach(countUp);
      if (e.target.matches('[data-owen-count]')) countUp(e.target);
      io.unobserve(e.target);
    }), { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach((e) => io.observe(e));
  }

  function countUp(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    const raw = el.dataset.owenCount || el.textContent;
    const num = parseFloat(raw.replace(/\s/g, '').replace(',', '.'));
    if (!isFinite(num) || reduce) return;
    const dec = (raw.split(/[,.]/)[1] || '').length;
    const t0 = performance.now(), dur = 1400;
    const fmt = (v) => v.toLocaleString('pl-PL', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur), k = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(num * k);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    };
    requestAnimationFrame(step);
  }

  function initCompare(root) {
    root.querySelectorAll('[data-owen-cmp]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const r = box.querySelector('input[type=range]');
      const set = (v) => box.style.setProperty('--pos', v + '%');
      r.addEventListener('input', () => set(r.value));
      set(r.value);
      if (!reduce && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => {
          if (!es[0].isIntersecting) return;
          io.disconnect();
          let t0 = null;
          const anim = (t) => { t0 = t0 || t; const p = Math.min(1, (t - t0) / 1600); const v = 50 + Math.sin(p * Math.PI * 2) * 22 * (1 - p); set(v); r.value = v; if (p < 1) requestAnimationFrame(anim); };
          requestAnimationFrame(anim);
        }, { threshold: 0.5 });
        io.observe(box);
      }
    });
  }

  function initGlow(root) {
    if (reduce || !matchMedia('(hover:hover)').matches) return;
    root.querySelectorAll('[data-owen-glow]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      el.addEventListener('pointermove', (e) => {
        const b = el.getBoundingClientRect();
        el.style.setProperty('--gx', (e.clientX - b.left) + 'px');
        el.style.setProperty('--gy', (e.clientY - b.top) + 'px');
      });
    });
  }

  // girlanda w kafelku: migotanie tylko gdy widać ją na ekranie (stała animacja przerysowywała stronę co klatkę)
  function initGarland(root) {
    if (!('IntersectionObserver' in window)) return;
    root.querySelectorAll('.owen-garland').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      new IntersectionObserver((es) => es.forEach((e) => el.classList.toggle('is-on', e.isIntersecting))).observe(el);
    });
  }

  function initQa(root) {
    root.querySelectorAll('[data-owen-qa]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const chips = [...box.querySelectorAll('.owen-qa__chips .owen-chip')];
      chips.forEach((c) => c.addEventListener('click', () => {
        chips.forEach((x) => x.setAttribute('aria-pressed', x === c ? 'true' : 'false'));
        box.querySelectorAll('details').forEach((d) => { d.hidden = !!c.dataset.cat && d.dataset.cat !== c.dataset.cat; });
      }));
    });
  }

  function initCalc(root) {
    root.querySelectorAll('[data-owen-calc]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const out = box.querySelector('[data-out]');
      const empty = box.querySelector('[data-empty]');
      const show = (html) => { empty.hidden = !!html; out.innerHTML = html || ''; };
      if (box.dataset.type === 'length') {
        const chips = [...box.querySelectorAll('[data-len]')];
        const units = [...box.querySelectorAll('[data-unit]')];
        const lab = box.querySelector('[data-lab]');
        const input = box.querySelector('input[type=number]');
        let cur = chips.find((c) => c.getAttribute('aria-pressed') === 'true') || chips[0];
        let unit = units.length ? 'tree' : 'm';
        const word = (n) => (n === 1 ? 'komplet' : ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100) ? 'komplety' : 'kompletów'));
        const fmt = (x) => x.toLocaleString('pl-PL', { maximumFractionDigits: 1 });
        const calc = () => {
          const v = parseFloat((input.value || '').replace(',', '.'));
          if (!cur || !(v > 0)) { show(''); return; }
          /* choinka: owijanie spiralą co ok. 20 cm, orientacyjnie 4,5 × wysokość² metrów przewodu */
          const L = unit === 'tree' ? Math.max(1, Math.round(4.5 * v * v)) : v;
          const lit = parseFloat(String(cur.dataset.len).replace(',', '.'));
          const n = Math.max(1, Math.ceil(L / lit));
          const max = parseInt(cur.dataset.max, 10);
          const warn = max && n > max ? `<p>To więcej niż ${max} kompletów w jednym ciągu. Podziel oświetlenie na ${Math.ceil(n / max)} obwody, każdy z własnego gniazdka.</p>` : '';
          const price = cur.dataset.price ? pln(Number(cur.dataset.price) * n) : '';
          const need = unit === 'tree' ? `Choinka ${fmt(v)} m potrzebuje ok. ${fmt(L)} m światła.` : `Na Twoje ${fmt(L)} m.`;
          show(`<div class="owen-calc__res"><span class="owen-calc__big">${n}<small>${word(n)}</small></span><p>${need} ${n} ${word(n)} ${word(n) === 'komplety' ? 'dają' : 'daje'} razem ${fmt(lit * n)} m.${price ? ' Łącznie ' + price + '.' : ''}</p>${warn}<form data-owen-add method="post" action="/cart/add"><input type="hidden" name="id" value="${cur.dataset.vid}"><input type="hidden" name="quantity" value="${n}"><button type="submit" class="owen-btn owen-btn--blue" data-added="Dodano do koszyka">Dodaj ${n} ${word(n)} do koszyka</button></form></div>`);
        };
        chips.forEach((c) => c.addEventListener('click', () => { chips.forEach((x) => x.setAttribute('aria-pressed', x === c ? 'true' : 'false')); cur = c; calc(); }));
        units.forEach((u) => u.addEventListener('click', () => {
          units.forEach((x) => x.setAttribute('aria-pressed', x === u ? 'true' : 'false'));
          unit = u.dataset.unit;
          if (lab) lab.textContent = u.dataset.label;
          input.placeholder = u.dataset.ph;
          input.value = '';
          show('');
          input.focus({ preventScroll: true });
        }));
        input.addEventListener('input', calc);
      } else {
        const tpls = [...box.querySelectorAll('template[data-optres]')];
        const pick = (t) => show(t ? t.innerHTML : '');
        if (box.dataset.mode === 'number') {
          const input = box.querySelector('input[type=number]');
          input.addEventListener('input', () => {
            const v = parseFloat((input.value || '').replace(',', '.'));
            if (!(v >= 0)) { pick(null); return; }
            pick(tpls.find((t) => { const a = parseFloat(t.dataset.min), b = parseFloat(t.dataset.max); return (isNaN(a) || v >= a) && (isNaN(b) || v < b); }) || tpls[tpls.length - 1]);
          });
        } else {
          const chips = [...box.querySelectorAll('[data-opt]')];
          chips.forEach((c) => c.addEventListener('click', () => {
            chips.forEach((x) => x.setAttribute('aria-pressed', x === c ? 'true' : 'false'));
            pick(tpls.find((t) => t.dataset.optres === c.dataset.opt));
          }));
        }
      }
      out.addEventListener('click', (e) => {
        if (e.target.closest('[data-owen-top]')) { e.preventDefault(); window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); }
      });
    });
  }

  /* POMOŻEMY DOBRAĆ: typ dekoracji + metry (albo wysokość choinki) + barwa -> jeden konkretny komplet i liczba sztuk */
  function initDob(root) {
    root.querySelectorAll('[data-owen-dob]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      let data = [];
      try { data = JSON.parse(box.querySelector('[data-dob-data]').textContent); } catch (e) { data = []; }
      const whats = [...box.querySelectorAll('[data-what] .owen-chip')];
      const cols = [...box.querySelectorAll('[data-c]')];
      const colWrap = box.querySelector('[data-colors]');
      const input = box.querySelector('input[type=number]');
      const lab = box.querySelector('[data-lab]');
      const out = box.querySelector('[data-out]');
      const empty = box.querySelector('[data-empty]');
      let what = whats[0], col = 'ciepla';
      const word = (n) => (n === 1 ? 'komplet' : ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100) ? 'komplety' : 'kompletów'));
      const fmt = (x) => x.toLocaleString('pl-PL', { maximumFractionDigits: 1 });
      const esc = (s) => String(s).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
      const syncColors = () => {
        const t = what.dataset.t;
        const pool = data.filter((d) => d.t === t);
        const noColor = t === 'girlanda';
        colWrap.hidden = noColor;
        cols.forEach((c) => { c.disabled = !pool.some((d) => d.c === c.dataset.c); });
        if (!noColor && !pool.some((d) => d.c === col)) {
          const ok = cols.find((c) => !c.disabled);
          if (ok) { col = ok.dataset.c; cols.forEach((x) => x.setAttribute('aria-pressed', x === ok ? 'true' : 'false')); }
        }
      };
      const run = () => {
        const v = parseFloat((input.value || '').replace(',', '.'));
        if (!(v > 0)) { empty.hidden = false; out.innerHTML = ''; return; }
        const t = what.dataset.t;
        const tree = what.dataset.unit === 'tree';
        const need = tree ? Math.max(1, Math.round(4.5 * v * v)) : v;
        const pool = data.filter((d) => d.t === t && (t === 'girlanda' || d.c === col));
        if (!pool.length) { empty.hidden = true; out.innerHTML = '<p>W tej barwie nie mamy teraz takiego kompletu. Wybierz inną barwę.</p>'; return; }
        /* najpierw jak najmniej kompletów, potem najmniej zbędnych metrów, potem cena */
        const best = pool.map((d) => {
          const l = parseFloat(d.l); const n = Math.max(1, Math.ceil(need / l));
          return { d, l, n, waste: n * l - need, total: n * d.p };
        }).sort((a, b) => a.n - b.n || a.waste - b.waste || a.total - b.total)[0];
        const { d, l, n } = best;
        const max = parseInt(d.x, 10);
        const warn = max && n > max ? `<p>To więcej niż ${max} kompletów w jednym ciągu, więc podziel je na ${Math.ceil(n / max)} obwody z osobnych gniazdek.</p>` : '';
        const lead = tree ? `Choinka ${fmt(v)} m potrzebuje ok. ${fmt(need)} m światła.` : `Na ${fmt(need)} m.`;
        empty.hidden = true;
        out.innerHTML = `<div class="owen-calc__res"><span class="owen-calc__big">${n}<small>${word(n)}</small></span><p>${lead} ${n} ${word(n)} po ${fmt(l)} m ${word(n) === 'komplety' ? 'dają' : 'daje'} razem ${fmt(n * l)} m. Łącznie ${pln(n * d.p)}.</p>${warn}<a class="owen-calc__prod" href="${esc(d.u)}"><span class="im">${d.i ? `<img src="${esc(d.i)}" alt="" loading="lazy" width="120" height="120">` : ''}</span><span><b>${esc(d.n)}</b><span>${pln(d.p)} / szt.</span></span></a><form data-owen-add method="post" action="/cart/add"><input type="hidden" name="id" value="${d.v}"><input type="hidden" name="quantity" value="${n}"><button type="submit" class="owen-btn owen-btn--blue" data-added="Dodano do koszyka">Dodaj ${n} ${word(n)} do koszyka</button></form></div>`;
      };
      whats.forEach((w) => w.addEventListener('click', () => {
        whats.forEach((x) => x.setAttribute('aria-pressed', x === w ? 'true' : 'false'));
        what = w;
        lab.textContent = w.dataset.label;
        input.placeholder = w.dataset.ph;
        syncColors();
        run();
      }));
      cols.forEach((c) => c.addEventListener('click', () => {
        if (c.disabled) return;
        cols.forEach((x) => x.setAttribute('aria-pressed', x === c ? 'true' : 'false'));
        col = c.dataset.c;
        run();
      }));
      input.addEventListener('input', run);
      syncColors();
    });
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-owen-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  function init(root = document) {
    initMission(root);
    initCountdown(root);
    initTabs(root);
    initSeo(root);
    initFbt(root);
    initReveal(root);
    initCompare(root);
    initGlow(root);
    initGarland(root);
    initQa(root);
    initCalc(root);
    initDob(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  // przedsprzedaż na karcie produktu: adnotacja w zamówieniu + tekst przycisku
  function initPreorder() {
    const el = document.querySelector('[data-owen-pre]');
    if (!el) return;
    const val = el.dataset.owenPre;
    document.querySelectorAll('form[action*="/cart/add"]').forEach((f) => {
      if (f.querySelector('[name="properties[Przedsprzedaż]"]')) return;
      const i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[Przedsprzedaż]'; i.value = val;
      f.appendChild(i);
      f.querySelectorAll('button[type="submit"], button[name="add"]').forEach((b) => {
        const w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT);
        for (let n = w.nextNode(); n; n = w.nextNode()) if (/koszyk/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\S.*\S|\S/, 'Zamów w przedsprzedaży');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initPreorder);
  if (document.readyState !== 'loading') initPreorder();

  // zestawy 1-5 szt. na karcie produktu: wybór ustawia ilość w formularzu (rabat liczy koszyk)
  document.addEventListener('change', (e) => {
    const r = e.target.closest('[data-owen-zestawy] input[type="radio"]');
    if (!r) return;
    const box = r.closest('[data-owen-zestawy]');
    box.querySelectorAll('.owen-zestawy__opt').forEach((o) => o.classList.toggle('is-on', o.contains(r)));
    const scope = box.closest('.product-details, .product-information, main') || document;
    scope.querySelectorAll('form[data-type="add-to-cart-form"] input[name="quantity"], input[name="quantity"]').forEach((q) => {
      q.value = r.value;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  // opinie: pokaż wszystkie
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-owen-op-wiecej]');
    if (!b) return;
    b.closest('.owen-op').querySelectorAll('.owen-op__card.is-ukryta').forEach((c) => c.classList.remove('is-ukryta'));
    b.remove();
  });
})();
